const React = require('react');
const { wrapFunctionalComponent } = require('utils/framework').default;
const Box = require('components/Box').default;

const Flex = React.forwardRef((props, ref) => {
    return (
        <Box
            ref={ref}
            {...props}
        />
    );
});

Flex.defaultProps = {
    display: 'flex'
};

module.exports = wrapFunctionalComponent(Flex, 'Flex');
